import { Link } from 'react-router-dom';

export default function ArticleShowcase() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-2/5 w-full">
            <Link
              to="/allchinabuyspreadsheet-guide"
              className="block rounded-3xl overflow-hidden cursor-pointer group"
            >
              <div className="aspect-[4/5] relative overflow-hidden rounded-3xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20creative%20workspace%20with%20open%20laptop%20showing%20analytics%20dashboard%2C%20notebook%20with%20handwritten%20notes%2C%20warm%20desk%20lamp%20glow%2C%20minimalist%20office%20setup%2C%20natural%20textures%2C%20terracotta%20and%20cream%20color%20palette%2C%20aspirational%20work%20from%20home%20aesthetic&width=800&height=1000&seq=article-preview-v2-2026&orientation=portrait"
                  alt="AllChinaBuySpreadsheet SEO Guide"
                  title="Mastering AllChinaBuySpreadsheet SEO Guide"
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            </Link>
          </div>

          <div className="lg:w-3/5">
            <span className="text-foreground-400 text-xs tracking-wider uppercase">SEO Guide</span>

            <h3 className="text-3xl md:text-4xl lg:text-5xl text-foreground-900 mt-3 leading-tight"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Mastering AllChinaBuy<br />
              <span className="text-foreground-400">Sheet SEO in 2026</span>
            </h3>

            <blockquote className="mt-8 text-foreground-600 text-base leading-relaxed max-w-lg border-l-2 border-accent-400 pl-5">
              &ldquo;The allchinabuyspreadsheet platform has completely transformed how I source products from China. With structured spreadsheets containing verified suppliers, profit margins, and TikTok trend data, I cut my research time by 80% and found my first winning product within the first week.&rdquo;
            </blockquote>

            <p className="mt-4 text-foreground-500 text-sm">
              — Dropshipping entrepreneur, 2026
            </p>

            <div className="mt-8 flex items-center gap-4 flex-wrap">
              <Link
                to="/allchinabuyspreadsheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                Read Full Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-200 text-foreground-600 rounded-full text-sm font-medium hover:border-foreground-400 hover:text-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                Browse Products
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}